import { computed } from 'vue'

import type { Location } from '@ds/types/Location'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CMS } from '~/scopes/cms/routes-names'

export function useTradeInUrl() {
  const withLocale = useRouteLocationWithLocale()

  const tradeInUrl = computed<Location>(() =>
    withLocale({
      name: CMS.BUYBACK,
      params: { pageName: 'home' },
    }),
  )

  return { tradeInUrl }
}
